<template>
  <div>
    <div :id="chartElementId"
         class="dashboard-sparkline"></div>
    <div>{{ currentValue }}</div>
  </div>
</template>

<script>
  import '../../../vendor/highcharts/SparklineExtension';
  import { v4 as uuid } from 'uuid';
  import Highcharts from 'highcharts';
  import makeMoment from '../../../common/moment/MomentFactory';
  import LocalizationService from '~/zf/frontend/common/localization/LocalizationService';
  import TimeRange from '../../../common/portlet/TimeRange';
  import { translator } from '~/zf/frontend/common/mixins';

  export default {
    name: 'SparklineChart',
    mixins: [translator],
    props: {
      chartSpecificData: {
        type: Object,
        required: true,
      },
      agGridParams: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        chartElementId: uuid(),
        currentValue: null,
      };
    },
    mounted() {
      const chartData = this.agGridParams.data[this.chartSpecificData.chartDataColumn];
      const highchartsOptions = this.createOptions(chartData);
      this.currentValue = this.agGridParams.value;
      this.$nextTick(() => {
        new Highcharts.Sparkline(this.chartElementId, highchartsOptions); // eslint-disable-line no-new
      });
    },
    methods: {
      areValuesAggregated() {
        if (this.chartSpecificData.type === 'irradiation') {
          return !([TimeRange.TODAY, TimeRange.YESTERDAY].includes(this.agGridParams.context.timerange));
        }
        const timeRanges = [TimeRange.LAST_WEEK, TimeRange.MONTH];
        return timeRanges.includes(this.agGridParams.data.timerange);
      },
      createOptions(chartData) {
        const unit = this.areValuesAggregated() ? this.chartSpecificData.unitAggregated : this.chartSpecificData.unit;
        const { timerange } = this.agGridParams.context;

        return {
          series: [{
            color: this.chartSpecificData.color,
            data: Object.values(chartData),
            pointStart: 0,
          }],
          tooltip: {
            style: {
              width: 'auto',
            },
            valueDecimals: 2,
            formatter() {
              const timestamp = makeMoment(this.x);
              const timeRanges = [TimeRange.TODAY, TimeRange.YESTERDAY];
              const timestampFormat = timeRanges.includes(timerange) ? timestamp.format('L LT') : timestamp.format('L');
              const tooltipHtml = `<small>${timestampFormat}</small>`;
              const localizedValue = this.y
                ? LocalizationService.localizeNumber(this.y, 2)
                : LocalizationService.localizeNumber(0, 2);

              return `${tooltipHtml}<br><small><b>${localizedValue} ${unit}</b></small>`;
            },
          },
          xAxis: {
            categories: Object.keys(chartData),
          },
        };
      },
    },
  };
</script>

<style scoped>
  .dashboard-sparkline {
    float: left;
    width: 80px;
  }
</style>
